import {Component, inject} from '@angular/core';
import {filter, from, map, switchMap, tap} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {AUTH_CONFIG, AuthService} from '../auth.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {LoadComponent} from '@brunata-angular/ui';

@Component({
    selector: 'app-auth-redirect',
    standalone: true,
    imports: [LoadComponent],
    template: `
        <div class="m-3 text-center">
            <app-load />
        </div>
    `,
})
export class AuthRedirectComponent {
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly config = inject(AUTH_CONFIG);
    private readonly authService = inject(AuthService);
    private readonly router = inject(Router);

    constructor() {
        this.activatedRoute.queryParamMap
            .pipe(
                takeUntilDestroyed(),
                tap(params => {
                    const isPasswordReset =
                        (params.get('error_description')?.startsWith('AADB2C90118') ?? false) ||
                        ((this.config.treatServerErrorAsPasswordReset ?? false) &&
                            params.get('error') === 'server_error');
                    if (isPasswordReset) {
                        document.location.href =
                            this.config.buildPasswordResetUrl?.() ?? '/reset-password';
                    } else if (params.has('code') === false) {
                        void this.router.navigate(['/']);
                    }
                }),
                map(params => params.get('code')),
                filter((code): code is string => code !== null),
                switchMap(code =>
                    from(this.authService.getAndStoreAccessTokenFromAuthRedirect(code)),
                ),
            )
            .subscribe({
                next: () => {
                    void this.router.navigate(['/'], {replaceUrl: true});
                },
                error: error => {
                    console.error('Error: ', error);
                    void this.router.navigate(['/']);
                },
            });
    }
}
